import React from "react";
import { ConfirmationModal } from "../../components";
import { useApproveMsgMutation } from "../../store";

const ApproveMessage = ({ show, onHide, id }) => {
    const [approveMsg, { isLoading, isSuccess, error }] = useApproveMsgMutation();

    const ApproveHandler = (e) => {
        e.preventDefault();
        approveMsg({ id: id });
    };

    return (
        <ConfirmationModal
            show={show}
            onHide={onHide}
            title="Approve Message"
            body="Do you really want to approve this message?"
            successMessage="Message Approved Successfully!"
            submitHandler={ApproveHandler}
            reducerProps={{
                loading: isLoading,
                success: isSuccess,
                error,
            }}
        ></ConfirmationModal>
    );
};

export default ApproveMessage;
